module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-getting-past-the-addicted-self-large@2x.5972aa82.png";